<template>
  <div
    style="
      box-sizing: border-box;
      padding: 10px 20px 31px 20px;
      min-width: 1066px;
    "
  >
    <div class="autoassess">
      <h4 class="autoassessTitle">自动回评</h4>
      <!-- 表格体 -->
      <div class="content">
        <!-- 描述 -->
        <div class="describe">
          <img src="@/assets/images/autoassess_icon.png" class="icon" />
          多个评价策略可供选择，自动给买家评价，全面保障店铺DSR评分
        </div>
        <!-- 头部按钮 -->
        <header class="head">
          <button
            class="create"
            v-zoom="{ from: pageName, name: '创建模板' }"
            @click="createTplFlag = true"
          >
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 9px 0px 0px 6px;
              "
            />创建模板
          </button>
          <div class="right">
            <div>
              开启状态:
              <el-select
                v-model="searchForm.isOpen"
                placeholder="请选择"
                style="width: 280px; margin-left: 6px"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="开启" :value="1"></el-option>
                <el-option label="关闭" :value="2"></el-option>
              </el-select>
              <el-input
                v-model="searchForm.templetName"
                placeholder="请输入模板名称"
                style="width: 280px; margin: 0 16px 0 8px"
              ></el-input>
            </div>

            <button class="search" @click="inquire">
              <i class="el-icon-search" style="marginright: 4px"></i>查询
            </button>
            <button class="reset" @click="replacement">重置</button>
          </div>
        </header>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-loading="talbeLoading"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            prop="templetName"
            label="模板名称"
            width="160"
          ></el-table-column>
          <el-table-column prop="content" width="500" label="回评内容">
            <template slot="header" slot-scope="scope">
              <span>回评内容</span> &nbsp;
              <span
                class="open"
                v-show="!tableOpenAll"
                @click="tableOpenAll = true"
                >（展开全部）</span
              >
              <span
                class="stop"
                v-show="tableOpenAll"
                @click="tableOpenAll = false"
                >（收起全部）</span
              >
            </template>
            <template slot-scope="scope">
              <el-tooltip
                class="tooltip"
                effect="light"
                :content="scope.row.content"
                placement="top"
              >
                <div class="hoveTitle" v-show="!tableOpenAll">
                  {{ scope.row.content }}
                </div>
              </el-tooltip>
              <div class="hoveTitleShowMore" v-show="tableOpenAll">
                {{ scope.row.content }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="任务时间" width="120">
            <template slot-scope="scope">{{
              scope.row.persistentOpenFlag == 1 ? "持续开启" : "固定时段"
            }}</template>
          </el-table-column>

          <el-table-column
            prop="commentScore"
            label="针对星级"
            width="120"
          ></el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="operateTime"
            label="最后修改时间"
            width="160"
          ></el-table-column>

          <el-table-column width="180">
            <template slot="header" slot-scope="scope">
              <div>
                优先级
                <el-tooltip
                  class="item"
                  effect="light"
                  content="数字越小优先级越高会优先发送，同一订单同时满足多个任务只发优先级高的，其他不发，避免重复，优先级相同则以最后修改时间先发。"
                  placement="top-start"
                >
                  <i
                    class="el-icon-question tips"
                    :style="{ color: '#CCCCCC' }"
                  ></i>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.sort"
                @change="handleChange($event, scope.row.id, 'sort')"
                :min="1"
                :max="5"
                size="small"
                style="width: 100px"
              ></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="开启状态" width="120">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isOpen"
                active-color="#49C568"
                v-zoom="{ from: pageName, name: '状态变化' }"
                :active-value="1"
                :inactive-value="2"
                @change="handleChange($event, scope.row.id, 'open')"
              ></el-switch>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                v-zoom="{ from: pageName, name: '编辑' }"
                @click="handleEdit(scope.row.id)"
                class="operationadd"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="text"
                v-zoom="{ from: pageName, name: '删除' }"
                @click="handleDelete(scope.row)"
                class="operationdelete"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.current"
          background
          :page-sizes="[10, 30, 50, 100]"
          :page-size="searchForm.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="total"
        ></el-pagination>
      </div>

      <!-- 创建模板抽屉 -->
      <create-tpl
        :drawer="createTplFlag"
        @close="handlecreateTplShow"
        :editData="editData"
      ></create-tpl>
    </div>
  </div>
</template>
<script
  type="text/javascript"
  src="http://at.alicdn.com/t/font_2060771_oi1gp0ag4t.js"
></script>

<script>
import createTpl from "./createTpl";
import {
  getAutoAssessList,
  openState,
  delAutoAssess,
  getDetails,
} from "@/api/serviceCenter/autoReplyComment";

export default {
  name: "autoassess",
  components: {
    createTpl,
  },
  data() {
    return {
      pageName: "售后中心-自动回评",
      searchForm: {
        // 查询条件
        isOpen: "",
        templetName: null,
        current: 1, // 表格当前页
        size: 10, // 分页数量
      },
      total: 0,
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      tableOpenAll: false, // 回评内容展开
      createTplFlag: false, // 创建模板抽屉状态控制
      editData: {}, // 编辑模板的数据
    };
  },
  created() {
    this.getAutoAssessList();

    // 埋点
    this.buriedPoint(1, '自动回评', '售后中心', '评价管理')
  },
  methods: {
    /**
     * 获取自动回评列表
     */
    getAutoAssessList() {
      this.talbeLoading = true;
      getAutoAssessList(this.searchForm).then((res) => {
        if (res && res.code == 1) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.talbeLoading = false;
        }
      });
    },
    /**
     * 模板优先级变化 || 模板开启状态
     */
    handleChange(val, id, type) {
      let params = {
        id,
      };
      type == "sort" ? (params.sort = val) : (params.isOpen = +val);
      openState(params).then((res) => {
        if (res && res.code == 1) {
          this.$message.success("修改成功");
          this.getAutoAssessList();
        }else {
          if(res.data){
            this.$message.error(res.data.message)
          }else{
            this.$message.error(res.message)
          }
        }
      });
    },
    /**
     * 模板编辑
     */
    handleEdit(id) {
      getDetails(id).then((res) => {
        if (res && res.code == 1) {
          res.data.commentScore = res.data.commentScore.split(",");
          res.data.goodsList = res.data.itemData;
          delete res.data.itemData;
          this.editData = res.data;
          this.createTplFlag = true;
        }
      });
    },
    /**
     * 模板删除
     */
    handleDelete(row) {
      if (row.isOpen === 1) {
        this.$message.warning("开启状态的任务不可删除！");
        return;
      }
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      })
        .then(() => {
          delAutoAssess(row.id).then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.getAutoAssessList();
            } else{
              if(res.data){
                this.$message.error(res.data.message)
              }else{
                this.$message.error(res.message)
              }
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    /**
     * 分页变化
     */
    handleSizeChange(e) {
      this.searchForm.size = e;
      this.searchForm.current = 1;
      this.getAutoAssessList();
    },
    handleCurrentChange(e) {
      this.searchForm.current = e;
      this.getAutoAssessList();
    },
    /**
     * 创建模板隐藏
     */
    handlecreateTplShow(state) {
      this.createTplFlag = false;
      if (typeof state != "function" && state) this.getAutoAssessList();
      this.editData = {};
    },
    // 重置
    replacement() {
      this.searchForm.isOpen = 2;
      this.searchForm.templetName = null;
      this.getAutoAssessList();
    },
    // 查询
    inquire() {
      this.getAutoAssessList();
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table .el-table__header-wrapper th .cell {
  height: 60px;
  line-height: 50px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  color: #333333;
  background: #fafafa;
}
.autoassess {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: rgba(255, 255, 255, 1);
  .autoassessTitle {
    box-sizing: border-box;
    padding-left: 28px;
    height: 54px;
    margin: 0;
    line-height: 52px;
    border-bottom: 1px solid #f0f0f0;
    color: #2e3458;
    font-size: 16px;
    font-weight: bold;
  }
  .operationadd {
    padding-left: 0 !important;
    width: auto;
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .operationdelete {
    margin: 0;
    width: auto;
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    .describe {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-left: 16px;
      margin-bottom: 20px;
      height: 52px;
      background: #f7f8fe;
      color: #666;
      font-size: 14px;
      .icon {
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
    }
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      button {
        width: 98px;
        height: 32px;
        line-height: 30px;
        outline: none;
        border: none;
        border-radius: 3px;
        background-color: white;
        cursor: pointer;
        transition: all 0.2s;
      }
      .create {
        color: #fff;
        background-color: #fe4d45;
        &:hover {
          opacity: 0.9;
        }
      }
      .right {
        display: flex;
        align-items: center;
        color: #333;
        .search {
          margin-right: 8px;
          border: 1px solid rgba(254, 77, 69, 1);
          color: #fe4d45;
          &:hover {
            background-color: #fe4d45;
            color: #fff;
          }
        }
        .reset {
          border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
          color: rgba(0, 0, 0, 0.65);
          &:hover {
            border: 1px solid #fe4d45;
            color: #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
    }
    .open,
    .stop {
      color: rgb(127, 133, 233);
      font-weight: 400;
      cursor: pointer;
    }
    .tooltip {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
